const Reflux = require('@muzzylane/reflux');
const isObject = require('lodash/isObject');

const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const AssetUtil = require('../util/asset');

const ShortCourseActions = Reflux.createActions({
    getShortCourse: { children: ['completed', 'failed'] },
    getChannelShortCourses: { children: ['completed', 'failed'] },
    getProjectShortCourses: { children: ['completed', 'failed'] },
    getShortCourseWithLatestDoc: { children: ['completed', 'failed'] },
    getShortCourseWithDocAtVersion: { children: ['completed', 'failed'] },
    createShortCourse: { children: ['completed', 'failed'] },
    addShortCourseVersionAsset: { children: ['completed', 'failed'] },
    saveShortCourseVersion: { children: ['completed', 'failed'] },
    publishShortCourse: { children: ['completed', 'failed'] },
    updateShortCourse: { children: ['completed', 'failed'] },
    renameShortCourse: { children: ['completed', 'failed'] },
    archiveShortCourse: { children: ['completed', 'failed'] },
    copyShortCourse: { children: ['completed', 'failed'] },
    transferShortCourse: { children: ['completed', 'failed'] },
    getShortCourseSaves: { children: ['completed', 'failed'] },
    unpublishShortCourse: { children: ['completed', 'failed'] },
    getEditLockStatus: { children: ['completed', 'failed'] },
    getCommentInfo: { children: ['completed', 'failed'] },
    updateComment: { children: ['completed', 'failed'] },
    publishIsBreaking: { children: ['completed', 'failed', 'reset'] },
    getLicensesForShortCourse: { children: ['completed', 'failed'] },
    getShortCourseLicense: { children: ['completed', 'failed'] },
    getShortCourseLicenses: { children: ['completed', 'failed'] },
    addShortCourseLicense: { children: ['completed', 'failed'] },
    updateShortCourseLicense: { children: ['completed', 'failed'] },
    deleteShortCourseLicense: { children: ['completed', 'failed'] },
    startBuyShortCourseCheckout: { children: ['completed', 'failed'] },
    adminAddLicenseForUser: { children: ['completed', 'failed'] },
});

ShortCourseActions.getShortCourse.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.shortCourseId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}`, 'GET')
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

ShortCourseActions.getChannelShortCourses.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/short_courses`, 'GET')
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

ShortCourseActions.getProjectShortCourses.listen(function(actionId, params) {
    if (!params.projectId || !params.channelId) {
        this.failed(actionId, params.projectId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/project/${params.projectId}/short_courses`, 'GET')
        .then(res => this.completed(actionId, params.channelId, params.projectId, res))
        .catch(err => this.failed(actionId, params.channelId, params.projectId, err));
});

ShortCourseActions.getShortCourseWithLatestDoc.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.shortCourseId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}`, 'get')
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

ShortCourseActions.getShortCourseWithDocAtVersion.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.shortCourseId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    let versionSuffix = '';
    if (params.version) {
        versionSuffix = `/{params.version}`;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}${versionSuffix}`, 'get')
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

ShortCourseActions.createShortCourse.listen(function(actionId, params) {
    if (!params.title) {
        this.failed(actionId, params.channelId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    if (!params.projectId) {
        this.failed(actionId, params.channelId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.channelId) {
        this.failed(actionId, params.channelId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectId}/short_courses/create`, 'POST', JSON.stringify({
            title: params.title
        }))
        .then(res => this.completed(actionId, params.channelId, params.projectId, res))
        .catch(err => this.failed(actionId, params.channelId, params.projectId, err));
});


ShortCourseActions.addShortCourseVersionAsset.listen(function(actionId, params, files, callback) {
    const self = this;
    if (!params.assetType) {
        params.assetType = 'image';
    }
    
    if (!params.assetType || ! params.courseHash) {
        this.failed(actionId, params.assetType, params.courseHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.assetType !== 'image') {
        // TODO: support other types (if we ever need any)
        this.failed(actionId, params.assetType, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    ServerRequest.makeUploadRequest('/authoring/create_course_version_asset', 'POST', params, files, AssetUtil.validateImageMimeType)
        .then((res)=>{
            self.completed(actionId, params, res);
            console.log("create_course_version_asset result",res);  // FIXME: remove debug spam
            if (callback) {
                callback(res.url);
            }
            console.log(JSON.stringify(res)); // FIXME: remove debug spam
        })
        .catch(err => self.failed(actionId, params, err));
});

ShortCourseActions.saveShortCourseVersion.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.shortCourseId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!isObject(params.doc)) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

	console.log("params.doc:",params.doc); // FIXME: remove debug spam

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/save`, 'POST', JSON.stringify({
            ...params.doc
        }))
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

ShortCourseActions.publishShortCourse.listen(function(actionId, params) {
    if (!params.shortCourseId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/publish`, 'POST', JSON.stringify({
            publish_message: params.publish_message,
            force_bump_major: params.force_bump_major,
            update_inactive: params.update_inactive,
            update_active: params.update_active,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ShortCourseActions.updateShortCourse.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.shortCourseId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const additionalArgs = {};
    if (params.course_license_meta_data) {
        additionalArgs.course_license_meta_data = params.course_license_meta_data;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}`, 'PATCH', JSON.stringify({
            display_title: params.display_title,
            description: params.description,
            image_url: params.image_url,
            ...additionalArgs
        }))
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

ShortCourseActions.renameShortCourse.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.shortCourseId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.title) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}`, 'PATCH', JSON.stringify({
            title: params.title,
        }))
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

ShortCourseActions.archiveShortCourse.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, null, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.projectId) {
        this.failed(actionId, params.channelId, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.shortCourseId) {
        this.failed(actionId, params.channelId, params.projectId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}`, 'DELETE')
        .then(res => this.completed(actionId, params.channelId, params.projectId, params.shortCourseId, res))
        .catch(err => this.failed(actionId, params.channelId, params.projectId, params.shortCourseId, err));
});

ShortCourseActions.copyShortCourse.listen(function(actionId, params) {
    if (!params.title) {
        this.failed(actionId, params.shortCourseId, params.toProjectId, params.fromProjectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    if (!params.shortCourseId || !params.channelId || !params.toProjectId || !params.fromProjectId) {
        this.failed(actionId, params.shortCourseId, params.channelId, params.toProjectId, params.fromProjectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS} ));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/copy`, 'POST', JSON.stringify({
            title: params.title,
            projectId: params.toProjectId,
        }))
        .then(res => this.completed(actionId, params.shortCourseId, params.channelId, params.toProjectId, params.fromProjectId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, params.channelId, params.toProjectId, params.fromProjectId, err));
});

ShortCourseActions.transferShortCourse.listen(function(actionId, params) {
    if (!params.shortCourseId || !params.channelId || !params.toProjectId || !params.fromProjectId) {
        this.failed(actionId, params.shortCourseId, params.channelId, params.toProjectId, params.fromProjectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS} ));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/transfer`, 'POST', JSON.stringify({
            projectId: params.toProjectId,
        }))
        .then(res => this.completed(actionId, params.shortCourseId, params.channelId, params.toProjectId, params.fromProjectId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, params.channelId, params.toProjectId, params.fromProjectId, err));
});

ShortCourseActions.getShortCourseSaves.listen(function(actionId, params) {
    if (!params.shortCourseId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/all/saves`, 'GET')
        .then(res => this.completed(actionId, params.shortCourseId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, err));
});

ShortCourseActions.unpublishShortCourse.listen(function(actionId, params) {
    if (!params.shortCourseId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/unpublish`, 'POST', JSON.stringify({
            unpublish_message: params.unpublishMessage || "",
        }))
        .then(res => this.completed(actionId, params.shortCourseId, params.channelId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, params.channelId, err));
});

ShortCourseActions.getEditLockStatus.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/lock_status`, 'POST', JSON.stringify({})) // TEMP used as POST to avoid overlap with getShortCourse endpoint
        .then(res  => this.completed(actionId, params.projectId, params.shortCourseId, res))
        .catch(err  => this.failed(actionId, err));
});

ShortCourseActions.getCommentInfo.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/all/comment_info`, 'GET')
    .then(res => self.completed(actionId, params.shortCourseId, res))
    .catch(err => self.failed(actionId, params.shortCourseId, err));
});

ShortCourseActions.updateComment.listen(function(actionId, params) {
    const self = this;
    let data = {
        action:params.commentAction
    };
    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/update_comment`, 'POST', JSON.stringify(data))
    .then(res => self.completed(actionId, params, res))
    .catch(err => self.failed(actionId, params, err));
});

ShortCourseActions.publishIsBreaking.listen(function(actionId, params) {
    if (params.refresh) {
        this.reset(params.shortCourseId);
    }

    ServerRequest.makeRequest(`/authoring/short_courses/${params.shortCourseId}/publish/is_breaking`, 'GET')
        .then(res => this.completed(actionId, params.shortCourseId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, err));
});

ShortCourseActions.getLicensesForShortCourse.listen(function(actionId, params) {
    if (!params.shortCourseId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_licenses/course/${params.shortCourseId}`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));    
});

ShortCourseActions.getShortCourseLicenses.listen(function(actionId) {
    ServerRequest.makeRequest(`/authoring/short_course_licenses`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ShortCourseActions.getShortCourseLicense.listen(function(actionId, params) {
    if (!params.licenseToken) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_licenses/token/${params.licenseToken}`, 'GET')
        .then(res => this.completed(actionId, params.licenseToken, res))
        .catch(err => this.failed(actionId, params.licenseToken, err));
});

ShortCourseActions.addShortCourseLicense.listen(function(actionId, params) {
    // TODO validation?
    const data = {
        mzl_course_hash: params.shortCourseHash,
        token: params.token,
        cost: params.cost,
        sale_cost: params.saleCost,
        license_type_token: params.licenseTypeToken,
        join_mzl_course_instance_hash: params.joinCourseInstanceHash,
    };

    ServerRequest.makeRequest(`/authoring/short_course_licenses`, 'PUT', JSON.stringify(data))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ShortCourseActions.updateShortCourseLicense.listen(function(actionId, params) {
    const data = {
        token: params.newToken,
        cost: params.cost,
        sale_cost: params.saleCost,
        join_mzl_course_instance_hash: params.joinCourseInstanceHash,
    };

    ServerRequest.makeRequest(`/authoring/short_course_licenses/token/${params.token}`, 'PATCH', JSON.stringify(data))
        .then(res => this.completed(actionId, params.token, res))
        .catch(err => this.failed(actionId, err));
});

ShortCourseActions.deleteShortCourseLicense.listen(function(actionId, params) {
    if (!params.shortCourseHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.token) {
        this.failed(actionId, params.shortCourseHash, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_licenses/token/${params.token}`, 'DELETE', JSON.stringify({}))
        .then(res => this.completed(actionId, params.shortCourseHash, params.token, res))
        .catch(err => this.failed(actionId, params.shortCourseHash, params.token, err));
});

ShortCourseActions.startBuyShortCourseCheckout.listen(function(actionID, params) {
    return ServerRequest.makeRequest('/authoring/ecommerce/start_buy_short_course_checkout', 'POST', JSON.stringify(params))
    .then((res)=>{ this.completed(actionID, res) })
    .catch((err)=>{ this.failed(actionID, err) })
});

ShortCourseActions.adminAddLicenseForUser.listen(function(actionId, params) {
    if (!params.userEmail) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.licenseToken) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const data = {
        user_email: params.userEmail,
        license_token: params.licenseToken,
        instructor_email: params.instructorEmail || '',
    };

    return ServerRequest.makeRequest(`/authoring/short_course_licenses/user`, 'PUT', JSON.stringify(data))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

module.exports = ShortCourseActions;